import { type ReactElement, useCallback } from "react"

import DragDropWrapper, { useDraggableItemRefs } from "@/shared/drag-n-drop/DragDropWrapper"
import { GoalsSortType } from "@/shared/types/sort"

import BehavioralPracticeCard from "./BehavioralPracticeCard"

type Props = {
    practices: any[]
    archivedPractices: number[]
    sort: GoalsSortType
    showDrag?: boolean
    onBlurPractice: (index: number) => void
    onArchiveClick: (index: number) => void
    onDragEnd: (result: any) => void
    remove: (index: number) => void
    dragAreaId: string
    currentGoalIndex: number
}

const BehavioralPracticeList = ({
    practices,
    archivedPractices,
    sort,
    showDrag: _showDrag,
    onBlurPractice,
    onArchiveClick,
    onDragEnd,
    remove,
    dragAreaId,
    currentGoalIndex
}: Props) => {
    const isArchived = useCallback(
        id => {
            return archivedPractices?.includes(id)
        },
        [archivedPractices]
    )

    return (
        <DragDropWrapper onDrop={onDragEnd}>
            {practices.map((practice, index) => {
                const isArchivedPractice = isArchived(practice.id)

                return (
                    <CardWrapper
                        dropArea={dragAreaId}
                        key={practice.uuid}
                        practice={practice}
                        onBlurPractice={onBlurPractice}
                        remove={remove}
                        practicesLength={practices.length}
                        isArchivedPractice={isArchivedPractice}
                        showDrag
                        index={index}
                        sort={sort}
                        onArchiveClick={onArchiveClick}
                        currentGoalIndex={currentGoalIndex}
                    />
                )
            })}
        </DragDropWrapper>
    )
}

function CardWrapper({
    onBlurPractice,
    dropArea,
    remove,
    practice,
    practicesLength,
    isArchivedPractice,
    showDrag,
    index,
    sort,
    onArchiveClick,
    currentGoalIndex
}): ReactElement {
    const { containerRef, grabberRef }: ReturnType<typeof useDraggableItemRefs> = useDraggableItemRefs({
        index,
        id: practice.uuid,
        dropType: dropArea,
        payload: currentGoalIndex
    })

    return (
        <BehavioralPracticeCard
            {...{ remove }}
            onBlurPractice={onBlurPractice}
            previousValue={practice.description}
            sort={sort}
            index={index}
            snapshot={grabberRef}
            provider={containerRef}
            showDrag={practicesLength > 1 && !isArchivedPractice && showDrag}
            isArchived={isArchivedPractice}
            onArchiveClick={onArchiveClick}
        />
    )
}

export default BehavioralPracticeList
